module.exports = __webpack_public_path__ + "static/media/problem-definition-large@3x.a7ef98a3.png";